module.exports = __webpack_public_path__ + "static/media/Workday_Step2d_Image3.049ad1ee.jpg";